/**
 * D13: Teacher Practice Assignments (Huiswerk)
 * Source: Teacher portal — "Huiswerk opgeven" feature
 */

import { USE_BACKEND, readJson, writeJson } from '../helpers';
import type { PracticeAssignment } from '../../assessment';
const PRACTICE_ASSIGNMENTS_KEY = 'practice_assignments';

/** Get all teacher-created practice assignments */
export async function getPracticeAssignments(): Promise<Record<string, PracticeAssignment>> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  return readJson<Record<string, PracticeAssignment>>(PRACTICE_ASSIGNMENTS_KEY, {});
}

/** Save or update a teacher practice assignment */
export async function savePracticeAssignment(id: string, assignment: PracticeAssignment): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, PracticeAssignment>>(PRACTICE_ASSIGNMENTS_KEY, {});
  all[id] = assignment;
  writeJson(PRACTICE_ASSIGNMENTS_KEY, all);
}

/** Delete a teacher practice assignment */
export async function deletePracticeAssignment(id: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, PracticeAssignment>>(PRACTICE_ASSIGNMENTS_KEY, {});
  delete all[id];
  writeJson(PRACTICE_ASSIGNMENTS_KEY, all);
}

/** Archive a teacher practice assignment */
export async function archivePracticeAssignment(id: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, PracticeAssignment>>(PRACTICE_ASSIGNMENTS_KEY, {});
  const assignment = all[id];
  if (!assignment) return;
  assignment.status = 'archived';
  all[id] = assignment;
  writeJson(PRACTICE_ASSIGNMENTS_KEY, all);
}

/** Mark a practice assignment as completed by a specific student */
export async function markPracticeAssignmentCompletedByStudent(assignmentId: string, studentId: string): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented');
  }
  const all = readJson<Record<string, Record<string, unknown>>>(PRACTICE_ASSIGNMENTS_KEY, {});
  const assignment = all[assignmentId];
  if (!assignment) return;
  const completedBy = assignment.completedByStudentIds as string[] || [];
  if (!completedBy.includes(studentId)) {
    assignment.completedByStudentIds = [...completedBy, studentId];
    writeJson(PRACTICE_ASSIGNMENTS_KEY, all);
  }
}